import getButtonsFromPlugins from '../../utils/getButtonsFromPlugins';
export default function getBlockActionButtonsFromPlugins(editor) {
  return getButtonsFromPlugins(editor, 'blockActionButton');
}